module.exports = false;



//////////////////
// WEBPACK FOOTER
// /var/www/html/ic-automation/wp-content/themes/digitalcover/node_modules/core-js/internals/is-pure.js
// module id = 22
// module chunks = 0